enum EBinDiscountBannerTypes {
  BIN_DISCOUNT_BANNER_SET_DATA = 'BinDiscountBanner/SET_DATA',
  BIN_DISCOUNT_BANNER_SET_DATA_SUCCESS = 'BinDiscountBanner/SET_DATA_SUCCESS',
}

export default EBinDiscountBannerTypes;
